import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory } from '@fortawesome/free-solid-svg-icons';
import GTable from 'components/tables/GTable';
import { activityLogColumns } from '../columns/taskActivityLogsColumns';
import { ActivityLog, TaskActivityLogsModalProps } from '../types/activityLog';
import { GET_ACTIVITY_LOGS_BY_TASK_ID } from 'services/api/task';

const TaskActivityLogsModal: React.FC<TaskActivityLogsModalProps> = ({
  show,
  onHide,
  taskId,
  taskName
}) => {
  const {
    data: activityLogs = [],
    isLoading: isLoadingLogs,
    error: logsError,
    refetch: refetchActivityLogs
  } = useQuery({
    queryKey: ['activityLogs', taskId],
    queryFn: () => GET_ACTIVITY_LOGS_BY_TASK_ID(taskId),
    staleTime: 0,
    select: (response: any) => response.data,
    enabled: show,
    refetchOnWindowFocus: false
  });

  React.useEffect(() => {
    if (show) {
      refetchActivityLogs();
    }
  }, [show, refetchActivityLogs]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      className="task-modal-elevated"
      backdropClassName="task-modal-elevated-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <FontAwesomeIcon icon={faHistory} className="me-2" />
          Activity Logs for "{taskName}"
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoadingLogs ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2 text-muted">Loading activity logs...</p>
          </div>
        ) : logsError ? (
          <div className="alert alert-danger">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            Failed to load activity logs
          </div>
        ) : activityLogs.length === 0 ? (
          <div className="text-center py-4">
            <i className="bi bi-clock-history fs-1 text-muted"></i>
            <p className="text-muted mt-2">
              No activity logs found for this task
            </p>
          </div>
        ) : (
          <GTable
            data={activityLogs as ActivityLog[]}
            columns={activityLogColumns()}
            isLoading={isLoadingLogs}
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TaskActivityLogsModal;
